import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Feedback } from './feedback.models';

import { FeedbackPayload } from '@paymash/local-sdk/interfaces';

export const FeedbackActions = createActionGroup({
  source: 'Feedback',
  events: {
    Send: props<{ payload: FeedbackPayload }>(),
  },
});

export const FeedbackApiActions = createActionGroup({
  source: 'Feedback API',
  events: {
    'Send Success': props<{ feedback: Feedback }>(),
    'Send Failure': emptyProps(),
  },
});
